export const LiteCard: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ children, className, style }) => {
	return (
		<div className={`${className || ""} MuiPaper-root MuiPaper-elevation1`} style={{ ...style }}>
			{children}
		</div>
	);
};
